/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
/* eslint-disable react/button-has-type */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Plus, Search, ChevronDown } from 'lucide-react';
import ResponsiveTable from '../../../components/Table/Responsivetable';
import adminServices from '../../../services/adminServices';
import useDebounce from '../../../hooks/useDebounce';
import QuestionViewModal from '../components/QuestionViewModal';

const ChapterQuestions = () => {
    const navigate = useNavigate();
    const { chapterId } = useParams();
    const [chapterData, setChapterData] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sourceId, setSourceId] = useState(0);
    const [sourceCategory, setSourceCategory] = useState({ id: '', label: '' });
    const [viewQuestionOpen, setViewQuestionOpen] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [difficultyFilter, setDifficultyFilter] = useState('');
    const [creatorFilter, setCreatorFilter] = useState('');
    const [creatorsList, setCreatorsList] = useState([]);

    const debouncedSearch = useDebounce(searchQuery, 500);

    useEffect(() => {
        fetchAuthors();
    }, []);

    const fetchAuthors = async () => {
        try {
            const response = await adminServices.getAuthors();
            if (response.ok) {
                setCreatorsList(response.data);
            }
        } catch (error) {
            console.error('Error fetching authors:', error);
        }
    };

    useEffect(() => {
        if (chapterId) {
            setPage(1);
            fetchQuestionsAndChapterDetails(1, pageCount, debouncedSearch, difficultyFilter, creatorFilter);
        }
    }, [chapterId, debouncedSearch, difficultyFilter, creatorFilter]);

    const fetchQuestionsAndChapterDetails = async (currentPage = page, currentPageCount = pageCount, search = debouncedSearch, difficulty = difficultyFilter, creator = creatorFilter) => {
        setLoading(true);
        try {
            const result = await adminServices.getQuestionsByChapterId(chapterId, currentPage, currentPageCount, search, difficulty, creator);
            if (result.ok) {
                setChapterData(result.data);
                const assessmentSourceId = result.data?.chapterDetails?.assessmentSourceId;
                setSourceId(assessmentSourceId);
                if (assessmentSourceId) {
                    fetchSourceCategory(assessmentSourceId);
                }
                setQuestions(result.data?.chapterDetails?.questions || []);
                setTotalCount(result.data?.chapterDetails?.totalCount || 0);
                setTotalPages(result.data?.chapterDetails?.totalPages || 0);
            } else {
                console.error('API returned unsuccessful response:', result);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching questions:', error);
            setLoading(false);
        }
    };

    const fetchSourceCategory = async (assessmentSourceId) => {
        try {
            const response = await adminServices.getAssessmentSourceBasedonId(assessmentSourceId);
            const sourceData = response?.data || {};
            const assessmentTypeId = sourceData?.assessment_type_id || '';
            let assessmentTypeLabel = sourceData?.type || '';

            if (!assessmentTypeLabel) {
                try {
                    const listResult = await adminServices.getAssessmentSource('', '', '', 1, 200);
                    const sourceList = listResult?.data?.data || [];
                    const match = sourceList.find((item) => String(item.id) === String(assessmentSourceId));
                    assessmentTypeLabel = match?.type || '';
                } catch (listError) {
                    console.error('Error fetching source list for category:', listError);
                }
            }

            const category = { id: assessmentTypeId, label: assessmentTypeLabel };
            setSourceCategory(category);
            return category;
        } catch (error) {
            console.error('Error fetching source category:', error);
            return { id: '', label: '' };
        }
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
        fetchQuestionsAndChapterDetails(newPage, pageCount, debouncedSearch, difficultyFilter, creatorFilter);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handlePageSizeChange = (newPageCount) => {
        setPageCount(newPageCount);
        setPage(1);
        fetchQuestionsAndChapterDetails(1, newPageCount, debouncedSearch, difficultyFilter, creatorFilter);
    };

    const handleCloseViewModal = () => {
        setViewQuestionOpen(false);
        setSelectedQuestion(null);
    };

    const getDifficultyBadgeClass = (difficulty) => {
        const difficultyLower = difficulty?.toLowerCase();
        if (difficultyLower === 'easy') {
            return 'bg-green-100 text-green-700';
        }
        if (difficultyLower === 'medium') {
            return 'bg-yellow-100 text-yellow-700';
        }
        if (difficultyLower === 'hard') {
            return 'bg-red-100 text-red-700';
        }
        return 'bg-gray-100 text-gray-700';
    };

    const getTypeBadgeClass = (type) => {
        switch (type?.toUpperCase()) {
            case 'MCQ':
                return 'bg-blue-100 text-blue-700';
            case 'NUMERIC':
                return 'bg-purple-100 text-purple-700';
            case 'PASSAGE':
                return 'bg-indigo-100 text-indigo-700';
            default:
                return 'bg-gray-100 text-gray-700';
        }
    };

    const handleActionClick = async (action, question) => {
        switch (action) {
            case 'view':
                setSelectedQuestion(null);
                setViewQuestionOpen(true);
                try {
                    const result = await adminServices.getQuestionDetails(question.id);
                    if (result?.data) {
                        const questionData = Array.isArray(result.data) ? result.data : [result.data];
                        setSelectedQuestion(questionData);
                    } else {
                        setSelectedQuestion(question);
                    }
                } catch (error) {
                    console.error('Error fetching question details:', error);
                    setSelectedQuestion(question);
                }
                break;
            // case 'edit':
            //     console.log('Edit question:', question);
            //   // navigate(`/app/question-edit/${question.id}`);
            //     break;
            // case 'delete':
            //     console.log('Delete question:', question);
            //     break;
            default:
                break;
        }
    };

    // const handleCreateQuestion = async () => {
    //     let category = sourceCategory;
    //     if ((!category?.id && !category?.label) && sourceId) {
    //         category = await fetchSourceCategory(sourceId);
    //     }
    //     const prefill = {
    //         assessmentTypeId: category?.id || '',
    //         assessmentTypeLabel: category?.label || '',
    //         sourceId: sourceId || '',
    //         sourceTitle: chapterData?.chapterDetails?.sourceTitle || '',
    //         chapterId: chapterId || '',
    //         chapterName: chapterData?.chapterDetails?.moduleName || '',
    //     };
    //     try {
    //         sessionStorage.setItem('questionCreatePrefill', JSON.stringify(prefill));
    //     } catch (error) {
    //         console.error('Failed to store prefill data:', error);
    //     }
    //     navigate("/app/question-create", {
    //         state: {
    //             prefill,
    //         },
    //     })
    // };
    const handleCreateQuestion = async () => {
        let category = sourceCategory;
        if ((!category?.id && !category?.label) && sourceId) {
            category = await fetchSourceCategory(sourceId);
        }
        const prefill = {
            assessmentTypeId: category?.id || '',
            assessmentTypeLabel: category?.label || '',
            sourceId: sourceId || '',
            sourceTitle: chapterData?.chapterDetails?.sourceTitle || '',
            chapterId: chapterId || '',
            chapterName: chapterData?.chapterDetails?.moduleName || '',
        };

        navigate('/app/question-create', {
            state: { prefill, fromChapterPage: true },
        });
    };

    const handleBackToChapters = () => {
        navigate(`/app/source-chapters/${sourceId}`);
    };

    const columns = [
        {
            label: '#',
            key: 'index',
            render: (row, rowIndex) => (
                <span className="text-sm text-gray-600 font-medium">
                    {(page - 1) * pageCount + rowIndex + 1}
                </span>
            ),
        },
        {
            label: 'Question',
            key: 'title',
            render: (row) => {
                return (
                    <div className="max-w-md">
                        <p
                            className="text-sm text-gray-900 truncate"
                            dangerouslySetInnerHTML={{ __html: row.title || '' }}
                        />
                    </div>
                );
            },
        },
        {
            label: 'Type',
            key: 'question_type',
            render: (row) => (
                <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium uppercase ${getTypeBadgeClass(row.question_type)}`}>
                    {row.question_type_name}
                </span>
            ),
        },
        {
            label: 'Difficulty',
            key: 'difficulty',
            render: (row) => (
                <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium uppercase ${getDifficultyBadgeClass(row.difficulty)}`}>
                     {row.difficulty === 'foundation' ? '' : row.difficulty}
                </span>
            ),
        },
        {
            label: 'Created By',
            key: 'created_by',
            render: (row) => (
                <div className="flex flex-col">
                    <span className="text-sm text-gray-900">
                        {row.created_by || '-'}
                    </span>
                    {row.created_date && (
                        <span className="text-xs text-gray-400 mt-0.5">
                            {new Date(row.created_date).toLocaleDateString('en-US', {
                                month: 'short', day: '2-digit', year: 'numeric',
                            })}, {new Date(row.created_date).toLocaleTimeString('en-US', {
                                hour: '2-digit', minute: '2-digit', hour12: true,
                            })}
                        </span>
                    )}
                </div>
            ),
        },
        {
            label: 'Last Edited',
            key: 'last_edited',
            render: (row) => {
                if (!row.modify_date) {
                    return <span className="text-sm text-gray-400">Never edited</span>;
                }
                return (
                    <div className="flex flex-col">
                        <span className="text-sm text-gray-900">
                            {row.updated_by_name || '-'}
                        </span>
                        <span className="text-xs text-gray-400 mt-0.5">
                            {new Date(row.modify_date).toLocaleDateString('en-US', {
                                month: 'short', day: '2-digit', year: 'numeric',
                            })}, {new Date(row.modify_date).toLocaleTimeString('en-US', {
                                hour: '2-digit', minute: '2-digit', hour12: true,
                            })}
                        </span>
                    </div>
                );
            },
        },
        {
            label: 'Actions',
            key: 'actions',
            render: (row, index, onActionClick) => (
                <div className="flex items-center gap-2">
                    <button
                        id={`btn-view-question-${row.id}`}
                        onClick={() => onActionClick('view', row)}
                        className="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150"
                        title="View"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                    </button>
                    {/* <button
                        onClick={() => onActionClick('edit', row)}
                        className="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150"
                        title="Edit"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                    </button>
                    <button
                        onClick={() => onActionClick('delete', row)}
                        className="p-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors duration-150"
                        title="Delete"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    </button> */}
                </div>
            ),
        },
    ];

    const TitleSkeleton = () => {
        return (
            <div className="space-y-3 animate-pulse">
                <div className="h-8 bg-gray-200 rounded" />
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-gray-50 mt-12 p-4 sm:p-6 lg:p-8">
            <div className="mx-auto">
                {/* Back Button */}
                <button
                    id="back-to-chapters-btn"
                    onClick={handleBackToChapters}
                    className="flex items-center gap-2 text-gray-700 hover:text-gray-900 mb-6 transition-colors"
                >
                    <ArrowLeft size={20} />
                    <span className="font-medium">Back to Chapters</span>
                </button>

                <div className="mb-6">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900 mb-2">
                                {chapterData?.chapterDetails?.moduleName || <TitleSkeleton />}
                            </h1>
                            <p className="text-gray-600">
                                {chapterData?.chapterDetails?.sourceTitle} • {totalCount} questions
                            </p>
                        </div>
                        <button
                            id="create-question-btn"
                            onClick={handleCreateQuestion}
                            className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-150 shadow-sm"
                        >
                            <Plus size={20} className="mr-2" strokeWidth={2.5} />
                            Create Question
                        </button>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
                    <div className="flex flex-col md:flex-row gap-3">
                        {/* Search */}
                        <div className="relative flex-1">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                            <input
                                id="question-search-input"
                                type="text"
                                placeholder="Search questions..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                            />
                        </div>

                        {/* Difficulty Filter */}
                        <div className="relative w-full md:w-48">
                            <select
                                id="question-difficulty-filter"
                                value={difficultyFilter}
                                onChange={(e) => { setDifficultyFilter(e.target.value); setPage(1); }}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm appearance-none bg-white"
                            >
                                <option value="">All Difficulties</option>
                                <option value="Easy">Easy</option>
                                <option value="Medium">Medium</option>
                                <option value="Hard">Hard</option>
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={16} />
                        </div>

                        {/* Creator Filter */}
                        <div className="relative w-full md:w-48">
                            <select
                                id="question-creator-filter"
                                value={creatorFilter}
                                onChange={(e) => { setCreatorFilter(e.target.value); setPage(1); }}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm appearance-none bg-white"
                            >
                                <option value="">All Creators</option>
                                {creatorsList.map((creator) => (
                                    <option key={creator.id} value={creator.id}>
                                        {creator.name}
                                    </option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={16} />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    <ResponsiveTable
                        columns={columns}
                        data={questions}
                        loading={loading}
                        onActionClick={handleActionClick}
                        comingfrom="ChapterQuestion"
                    />
                    {questions.length > 0 && (
                        <div className="px-4 py-3 border-t border-gray-200 sm:px-6">
                            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                                <div className="text-sm text-gray-700">
                                    Showing <span className="font-medium">{(page - 1) * pageCount + 1}</span> to{' '}
                                    <span className="font-medium">
                                        {Math.min(page * pageCount, totalCount)}
                                    </span>{' '}
                                    of <span className="font-medium">{totalCount}</span> results
                                </div>

                                <div className="flex items-center gap-2">
                                    <select
                                        id="question-page-size-select"
                                        value={pageCount}
                                        onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                                        className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>

                                    <button
                                        id="question-pagination-prev-btn"
                                        onClick={() => handlePageChange(page - 1)}
                                        disabled={page === 1}
                                        className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                                    >
                                        Previous
                                    </button>

                                    {totalPages > 1 && (
                                        <div className="hidden sm:flex items-center gap-1">
                                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                let pageNum;
                                                if (totalPages <= 5) {
                                                    pageNum = i + 1;
                                                } else if (page <= 3) {
                                                    pageNum = i + 1;
                                                } else if (page >= totalPages - 2) {
                                                    pageNum = totalPages - 4 + i;
                                                } else {
                                                    pageNum = page - 2 + i;
                                                }
                                                return (
                                                    <button
                                                        key={i}
                                                        id={`question-page-btn-${pageNum}`}
                                                        onClick={() => handlePageChange(pageNum)}
                                                        className={`px-3 py-1.5 border rounded-lg text-sm font-medium transition-colors duration-150 ${page === pageNum
                                                                ? 'bg-indigo-600 text-white border-indigo-600'
                                                                : 'border-gray-300 text-gray-700 hover:bg-gray-50'
                                                            }`}
                                                    >
                                                        {pageNum}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    )}

                                    <button
                                        id="question-pagination-next-btn"
                                        onClick={() => handlePageChange(page + 1)}
                                        disabled={page === totalPages || totalPages === 0}
                                        className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <QuestionViewModal
                    open={viewQuestionOpen}
                    onClose={handleCloseViewModal}
                    questions={selectedQuestion}
                    questionTypeCode={selectedQuestion?.question_type_name}
                    sourceName={chapterData?.chapterDetails?.sourceTitle || ''}
                    chapterName={chapterData?.chapterDetails?.moduleName || ''}
                    sourceId={sourceId}
                    chapterId={chapterId}
                    // hideEditButton
                    fromChapterPage
                />
            </div>
        </div>
    );
};

export default ChapterQuestions;